(function (Account, $) {

  var app;

  Account.init = function(utils) {

    Account.app = new Vue({
      el: '#account-app',
      delimiters: ['${', '}'],
      data: {
        orders: []
      },
      methods: {
        formatPrice: function(value) {
          return Utils.formatPrice(value);
        }
      }
    });

    deserializeAccount();
    this.app.orders = orders;

    for(var i = 0; i < this.app.orders.length; i++) {
        var order = this.app.orders[i];
        Account.loadOrderData(order);
    }

    Account.bindUIActions();
  }

  Account.loadOrderData = function(order) {
    $.get(apiEndpoint + '/orders/' + order.id, function(response) {
      order.draftUrl = response.draft_url;
      order.orderStatusUrl = response.order_status_url;
      order.trackingUrl = response.tracking_url;

      console.log(order);

      Account.app.$forceUpdate();
    });
  }

  Account.bindUIActions = function () {

    $('.floating-label input').on('change', function() {
      if($(this).val())
        $(this).addClass('filled');
      else
        $(this).removeClass('filled');
    });

  }

}(window.Account = window.Account || {}, jQuery));